export const back = function(){
      window.history.back();  
}
 
export const checkLogin = function(response, token){
      console.log(token)
      if (response.data == "login to system please." || token == null){
        document.getElementById('logout').click()
        // this.$router.push('/')
      }
}

export const handleServerError = function(error){
      if (error.response.status === 401){
            // clear storage
            localStorage.removeItem("token");
          localStorage.removeItem("admin");
          localStorage.removeItem("username");
            window.location = "/"

      }
}


